import { render, staticRenderFns } from "./NewDisclosureForm.vue?vue&type=template&id=065a1167"
import script from "./NewDisclosureForm.vue?vue&type=script&lang=js"
export * from "./NewDisclosureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports